import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    isEditCliente: false,
    isEditVehiculo: false,
    clienteForm: {
        _id: null,
        nombre: null,
        apellido: null,
        celular: null,
        tipo_doc: null,
        numero_doc: null,
        email: null,
        ubicacion_name: null,
        ubicacion_id: null
    },
    vehiculoForm: {
        marca_id: null,
        marca_name: null,
        modelo_id: null,
        modelo_name: null,
        linea_id: null,
        linea_name: null,
        version_id: "",
        version_name: "",
        kilometraje: null,
        color_primario: null,
        color_secundario: null,
        precio: 0
    },
    archivos: [],
    citas: [],
    tareas: [],
    notas: [],
    actividades: [],
    operadores: [],
    tarea: {
        titulo: null,
        fecha: null,
        hora: null,
        responsable:null,
        estado: 'pendiente',
        id:"",
        index:null
    },
    cita: {
        titulo: null,
        lugar: null,
        inicio_date: null,
        inicio_time: null,
        fin_date:null,
        fin_time: null,
        description: null,
        estado: 'pendiente',
        participantes: [],
        index:null,
        id:null
    },
    nota: {
        description: null,
        estado: 'pendiente'
    },
    resultado: {
        estado: null,
        descripcion: "",
        id: "",
        index: 0,
        tipo_accion: null
    }
   
};
const mutations = {
    updateField,
    updatePanel: (state, payload) =>{
        const { modelorel, fichatecnica, clientes, acciones, actividades, archivos } = payload;
        state.clienteForm = {
            _id: clientes._id,
            nombre: clientes.nombre,
            apellido: clientes.apellido ? clientes.apellido : null,
            celular:clientes.celular,
            tipo_doc: clientes.meta_keys.tipo_doc,
            numero_doc: clientes.meta_keys.numero_doc,
            email: clientes.email,
            ubicacion_name: clientes.ubicacion_name,
            ubicacion_id: clientes.ubicacion_id
        };
        state.vehiculoForm = {
            ...state.vehiculoForm,
            kilometraje: fichatecnica.kilometraje,
            color_primario: fichatecnica.datos_vehiculo.color_primario,
            color_secundario: fichatecnica.datos_vehiculo.color_secundario,
            precio: fichatecnica.precio_publicacion,
            marca_name: modelorel.marca.name,
            modelo_name: modelorel.modelo,
            linea_name: modelorel.lineas.name,
            version_name: modelorel.version.name
        };
        const citas = _.filter(acciones, (accion) => {
            return accion.tipo_accion == 'cita';
        });
        const tareas = _.filter(acciones, (accion) => {
            return accion.tipo_accion == 'tarea';
        });
        const notas = _.filter(acciones, { tipo_accion: "nota" });
        state.citas = citas;
        state.tareas = tareas;
        state.notas = notas;
        state.actividades = actividades;
        state.archivos = archivos;
    },
    updateOperadores: (state, payload) =>{
        state.operadores = payload;
    },
    updateEditCliente: (state) => {
        state.isEditCliente = !state.isEditCliente;
    },
    updateEditVehiculo: (state) => {
        state.isEditVehiculo = !state.isEditVehiculo;
    },
    addCita: (state, payload) => {
        state.citas.push(payload);
    },
    addTarea: (state, payload) => {
        state.tareas.push(payload);
    },
    addNota: (state, payload) => {
        state.notas.push(payload);
    },
    updateDocumentos: (state, payload) => {
        state.archivos = payload;
    },
    addDocumento: (state, payload) => {
        state.archivos.push(payload)
    },
    removeDocumento: (state, payload) => {
        state.archivos.splice(payload, 1);
    },
    openModal: (state, payload) => {
        var { _id, tipo_accion } = payload.accion;
        state.resultado.id = _id;
        state.resultado.index = payload.index;
        state.resultado.tipo_accion = tipo_accion;
    },
    editModal: (state, payload) => {
        var { _id, tipo_accion, estado, id_responsable, meta_keys, titulo } = payload.accion;
        state.tarea.titulo=titulo;
        state.tarea.fecha=meta_keys.fecha;
        state.tarea.hora=meta_keys.hora;
        state.tarea.responsable= id_responsable;
        state.tarea.estado= estado;
        state.tarea.id= _id;
        state.tarea.index=payload.index;
        state.tarea.tipo_accion = tipo_accion;
    },
    resetTarea: (state) => {
        state.tarea.titulo="";
        state.tarea.fecha="";
        state.tarea.hora="";
        state.tarea.responsable= "";
        state.tarea.estado= "";
        state.tarea.id= "";
        state.tarea.index=null;
        state.tarea.tipo_accion = "";
    },
    editModalCita: (state, payload) => {
        var { _id, estado, tipo_accion, meta_keys, titulo, index } = payload.accion;
        state.cita.titulo = titulo;
        state.cita.lugar = meta_keys.lugar;
        state.cita.inicio_date = meta_keys.inicio_date;
        state.cita.inicio_time = meta_keys.inicio_time;
        state.cita.fin_date = meta_keys.fin_date;
        state.cita.fin_time = meta_keys.fin_time;
        state.cita.description = meta_keys.descripcion;
        state.cita.estado = estado;
        state.cita.participantes = meta_keys.participantes;
        state.cita.index = index;
        state.cita.id = _id;
    },
    resetCita: (state) => {
        state.cita.titulo = "";
        state.cita.lugar = "";
        state.cita.inicio_date = "";
        state.cita.inicio_time = "";
        state.cita.fin_date = "";
        state.cita.fin_time = "";
        state.cita.description = "";
        state.cita.estado = "";
        state.cita.participantes = "";
        state.cita.index = null;
        state.cita.id = "";
    },
    updateAccion: (state, payload) => {
        if(payload.tipo_accion == 'tarea'){
            var tarea = state.tareas[payload.index];
            tarea.estado = payload.estado;
            Object.assign(state.tareas[payload.index], tarea);
        }else{
            var cita = state.citas[payload.index];
            cita.estado = payload.estado;
            Object.assign(state.citas[payload.index], cita);
        }
    },
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
